export default __webpack_public_path__ + "static/media/react.2bef6f02.svg";